<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">انبار گردانی محصولات</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div class="row col-12">
                    <div class="col-6 mb-1">
                        <multiselect placeholder="انتخاب انبار" v-model="selectedStore" open-direction="bottom"
                            :options="stores" label="label" track-by="value" :searchable="true" :close-on-select="true"
                            :show-labels="false" :disabled="disabled"  @input="onStoreChange">
                            <template slot="noOptions">
                                موردی یافت نشد
                            </template>
                            <template slot="noResult">
                                موردی یافت نشد
                            </template>
                        </multiselect>
                    </div>
                </div>
                <br>
                <br>
                <div class="row mt-5">
                    <table v-if="product" class="table table-responsive-sm table-bordered table-hover">
                        <thead class="bg-light">
                            <tr>
                                <th>ردیف</th>
                                <th>عنوان</th>
                                <th>بارکد</th>
                                <th>قیمت(تومان)</th>
                                <th>موجودی ({{ selectedStore.label }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(variety,index) in product.varieties" :key="index">
                                <td class="font-weight-bold">{{ index + 1 }}</td>
                                <td>{{ variety.title }}</td>
                                <td>{{ variety.barcode }}</td>
                                <td>{{ variety.price | price}}</td>
                                <td class="d-flex justify-content-center">
                                    <b-form-input 
                                        type="number" 
                                        v-model="variety.quantity"
                                        style="max-width: 60%;"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer" v-if="product">
                <div class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-success text-right item-right" @click="submitData">انبار گردانی</button>
                </div>
            </div>  
        </div>
    </main>
</template>
<script>
    import WearehouseManagementLmpl from '@@/core/pages/WearehouseManagement/WearehouseManagementLmpl'
    export default {
        extends: WearehouseManagementLmpl
    }
</script>
<style scoped ></style>